import { urlToFilters } from "@/utils/search-url-transform";

/**
 * Count active filters to determine metadata level
 */
export function countActiveFilters(filters: ReturnType<typeof urlToFilters>): number {
	let count = 0;

	// Count location filter
	if (filters.locations && filters.locations.length > 0) {
		count++;
	}

	// Count property type filter (only if not default)
	if (filters.propertyType) {
		count++;
	}

	// Count bedrooms filter
	if (filters.bedrooms && (filters.bedrooms.min !== 1 || filters.bedrooms.max !== 1)) {
		count++;
	}

	// Count other significant filters
	if (filters.facing && filters.facing.length > 0) count++;
	if (filters.budget && (filters.budget.min !== 200000 || filters.budget.max !== 400000)) count++;
	if (filters.status && filters.status.length > 0) count++;
	if (filters.furnishing && filters.furnishing.length > 0) count++;
	if (filters.amenities && filters.amenities.length > 0) count++;
	if (filters.bathroomsMin && filters.bathroomsMin > 1) count++;
	if (filters.balconiesMin && filters.balconiesMin > 1) count++;
	if (filters.parkingsMin && filters.parkingsMin > 1) count++;
	if (filters.builtupAreaMin && filters.builtupAreaMin > 400) count++;
	if (filters.floors && (filters.floors.min !== 1 || filters.floors.max !== 2)) count++;

	return count;
}
